module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n\r\n      <header>\r\n          <h2>Logged in as <b>{{ $ctrl.authService.authData.email }}</b></h2>\r\n      </header>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/user/user.html
// module id = 1038
// module chunks = 0